/**
 * @fileoverview AllCaughtUpFooter — terminal "You're all caught up!" row
 * rendered at the bottom of a ReleaseNoteScrollArea. A Blueprint
 * `tick-circle` icon followed by a short congratulatory string,
 * styled like a non-ideal-state visual but inline.
 *
 * Foundry mapping: `bp6-non-ideal-state-visual` +
 * `release-notes__release-note-footer__1g6dw2s` with a `tick-circle` icon.
 */

import { Icon } from "@blueprintjs/core";
import type { ReactElement } from "react";

interface AllCaughtUpFooterProps {
  label?: string;
  className?: string;
}

export function AllCaughtUpFooter({
  label = "You're all caught up!",
  className,
}: AllCaughtUpFooterProps): ReactElement {
  return (
    <div data-testid="all-caught-up-footer" className={["bp-release-note-footer", className].filter(Boolean).join(" ")}>
      <Icon icon="tick-circle" size={20} aria-hidden />
      {label}
    </div>
  );
}
